import {FooterFull} from '@travel-frontend/ui-components';
import {useLocation} from 'react-router';

import {config} from '@/config';

export const Footer = () => {
  const {pathname, search} = useLocation();

  return (
    <FooterFull
      showTrustElement
      // @ts-expect-error ...
      links={config.footer.links}
      // @ts-expect-error ...
      socialLinks={config.footer.socialLinks}
      path={`${pathname}${search}`}
      brandName={import.meta.env.VITE_PORTAL_DOMAIN}
    />
  );
};
